/* External */
import {
  useEffect, useMemo, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List } from 'immutable';

/* Storage */
import { search } from '../storage/utils/actions';
import { selectMultiplePolymorphicEntities } from '../storage/selectors';

/* Utils */
import { REPORT_GA, STATUS_TYPES } from '../utils/constants';
import { gaService } from '../services/gaService';
import useRequestAndDelete from './useRequestAndDelete';

const MIN_CHARS_TO_SEARCH = 3;
const DEFAULT_SEARCH_COUNT = 20;

function useSearchResults(query, count = DEFAULT_SEARCH_COUNT) {
  const dispatch = useDispatch();
  const [requestId, setRequestId] = useState(undefined);
  const request = useRequestAndDelete(requestId);

  useEffect(() => {
    const trimedQuery = query?.trim();
    if (trimedQuery && count > 0) {
      if (trimedQuery.length >= MIN_CHARS_TO_SEARCH) {
        const action = search(query, count);
        setRequestId(action.requestId);
        dispatch(action);
        gaService.sendEvent({
          action: REPORT_GA.GA_EVENT_SEARCH,
          label: trimedQuery,
          category: REPORT_GA.GA_EVENT_CATEGORY_SEARCH,
        });
      }
    } else {
      setRequestId(undefined);
    }
  }, [query, count, dispatch]);

  const requestResults = request?.result?.contents;

  const resultsSelector = useMemo(() => {
    if (!requestResults) return () => undefined;

    return selectMultiplePolymorphicEntities(List(requestResults));
  }, [requestResults]);
  const searchResults = useSelector(resultsSelector);

  return {
    isFetching: request?.status === STATUS_TYPES.INIT_STATE,
    searchResults,
    areResultsLengthZero: Array.isArray(request?.result?.contents)
      && request?.result?.contents?.length === 0,
    minCharsToSearch: MIN_CHARS_TO_SEARCH,
  };
}

export default useSearchResults;
